export default {
      id: "eye-with-box-usage",
      viewBox: "0 0 16 10",
      url: __webpack_public_path__ + "sprite.svg#eye-with-box",
      toString: function () {
        return this.url;
      }
    }